<div class="overlay-header">
    <ng-content select=".overlay-header-item"></ng-content>
</div>
<div class="overlay-content">
    <ng-content select=".overlay-content"></ng-content>
</div>
<div class="overlay-footer">
    <ng-content select=".overlay-footer-item"></ng-content>
</div>
